var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9233 20.997C14.3027 21.1282 13.6592 21.1971 13 21.1971C7.89477 21.1971 3.75041 17.0527 3.75041 11.9475C3.75041 11.1745 3.12256 10.5461 2.34896 10.5461C1.57536 10.5461 0.94751 11.1745 0.94751 11.9475C0.94751 18.5999 6.34813 24 13 24C13.8582 24 14.6957 23.9103 15.5035 23.7393C16.2603 23.579 16.7446 22.8345 16.5843 22.0778C16.4245 21.321 15.6801 20.8367 14.9233 20.997ZM14.3033 2.78935C18.7924 3.4228 22.2495 7.2852 22.2495 11.9475C22.2495 15.246 20.519 18.1436 17.9174 19.7816C17.2626 20.1937 17.0659 21.0598 17.4785 21.714C17.8905 22.3687 18.7565 22.5655 19.4107 22.1534C22.7995 20.0193 25.0524 16.2444 25.0524 11.9475C25.0524 5.87142 20.5454 0.839656 14.6952 0.0139217C13.9294 -0.0942702 13.2197 0.439949 13.1115 1.2057C13.0033 1.97145 13.5376 2.68115 14.3033 2.78935ZM4.41582 8.49774C5.40693 6.03735 7.42614 4.09942 9.93978 3.21707C10.6697 2.96088 11.0536 2.16037 10.7974 1.43049C10.5413 0.700619 9.74077 0.316075 9.01145 0.57226C5.73711 1.72145 3.10743 4.24573 1.81585 7.45057C1.52716 8.16811 1.87472 8.98543 2.59226 9.27413C3.3098 9.56339 4.12712 9.21528 4.41582 8.49774Z",
    fill: "#FF3131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5ffd6257abaa923952609b2c39e82c28.svg";
export { ForwardRef as ReactComponent };